module.exports = __webpack_public_path__ + "static/media/hongtoushan.b03fb0d2.png";